<h2 class="g-card-title">Contacts</h2>

<ng-container *ngIf="loading == false && data && data.length != 0; else elseBlockContacts">
    <div class="al-grid grid-2-inner" *ngFor="let c of data">
        <span class="g-text-title">{{ c.contactType }}</span>

        <div style="cursor: pointer" (click)="openContact(c)">
            <profile-picture
                class="avatar"
                [size]="26"
                [primaryIdentifier]="c.identifier"
                [name]="getContactName(c.contactType)"
            >
            </profile-picture>

            <span class="g-text-content" style="padding-left: 10px">{{
                getContactName(c.contactType)
            }}</span>
        </div>
    </div>
</ng-container>

<ng-template #elseBlockContacts>
    <div *ngIf="loading; else notLoadingNoData">
        <spin-loader></spin-loader>
    </div>

    <ng-template #notLoadingNoData>
        <no-data-screen [noDataType]="noDataSelection"></no-data-screen>
    </ng-template>
</ng-template>
